import React, {useState} from 'react';
import {Dropdown} from 'react-bootstrap';
import {educationLevels} from '../EducationLevelSelection/EducationLevelSelection';
import {generateMenuData} from '../../utils/consts/menuConfig';
import {parseSelectedLevelsId, handleBachelorLinkClick} from '../DocumentLinksPage/DocumentLinksPage';
import './DropdownMenu.css';

const DropdownMenu = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const menuData = generateMenuData(educationLevels);

    const handleToggle = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    return (
        <div className='dropdownMenu__container'>
            {menuData.map((menu, index) => (
                <Dropdown
                    className='dropdownMenu__navigation__dropdown'
                    key={index}
                    show={openDropdown === index}
                    onToggle={() => handleToggle(index)}
                >
                    <Dropdown.Toggle className='dropdown-toggle-custom' id={`dropdown-basic-${index}`} variant="link">
                        {menu.title} <span className={`arrow-down ${openDropdown === index ? 'rotated' : ''}`}>▼</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {menu.items.map((item, idx) => (
                            item.changeSelectedProgram ? (
                                <Dropdown.Item href={item.href} key={idx} onClick={(event) =>
                                    handleBachelorLinkClick(event, parseSelectedLevelsId(menu.id))}>
                                    {item.label}
                                </Dropdown.Item>
                            ) : (
                                <Dropdown.Item href={item.href} key={idx}>
                                    {item.label}
                                </Dropdown.Item>
                            )
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            ))}
        </div>
    );
};

export default DropdownMenu;